<template>
    <div class="date_wrap">
        <button class="btn btn_xs ico btn_lgray_line" @click="action_BeforeDay"><v-icon>mdi-chevron-left</v-icon></button>

        <b>{{ dateString }}</b>
        <button class="btn btn_xs ico btn_lgray_line mgr_5" @click="action_NextDay"><v-icon>mdi-chevron-right</v-icon></button>
    </div>
</template>

<script>
function getWeekOfMonth(date) {
    // 주어진 날짜의 월의 첫째 날
    const firstDayOfMonth = moment(date).startOf('month')
    // 주어진 날짜
    const day = moment(date)

    // ISO 주차 계산 방식 사용 (월요일이 주의 시작일)
    const firstDayWeekNumber = firstDayOfMonth.isoWeek()
    const currentDayWeekNumber = day.isoWeek()

    // 첫째 주차와 현재 날짜의 주차 차이를 계산하여 월의 주차를 결정
    return currentDayWeekNumber - firstDayWeekNumber + 1
}

import { monitorState, updateSelectedPeriod } from './monitor-popup-state'

import moment from '@/util/MPMoment'

export default {
    name: 'DateFilter',
    data() {
        return {
            monitor: monitorState,
        }
    },
    computed: {
        selectedPeriodType: function () {
            return this.monitor.selectedPeriod.periodType
        },
        selectedDate: function() { return this.monitor.selectedPeriod.endDate },
        dateString: function () {
            if (this.selectedPeriodType === 'day') {
                return this.selectedDate.format(this.$t('reservationwindow.reservationmonitor.label_datedaily'))
            }

            if (this.selectedPeriodType === 'week') {
                if (this.hospitalLocale == 'en') {
                    return this.selectedDate.format(this.$t('reservationwindow.reservationmonitor.label_dateweekly')).replace('{n}', 'W' + getWeekOfMonth(this.selectedDate))
                }
                return this.selectedDate.format('YYYY년 M월') + ' ' + getWeekOfMonth(this.selectedDate) + '주차'
            }

            if (this.selectedPeriodType === 'month') {
                return this.selectedDate.format(this.$t('reservationwindow.reservationmonitor.label_datemonthly'))
            }
            return ''
        }
    },
    methods: {
        async handler_DayChange(selectedPeriodType, day) {
            let result = await this.AlertController.runCheckLogics()
            if (result === false) {
                return
            }

            let date

            if (selectedPeriodType === 'day') {
                date = moment(this.selectedDate).add(day, 'day').startOf('days')
            }

            if (selectedPeriodType === 'week') {
                date = moment(this.selectedDate)
                    .add(day * 7, 'day')
                    .startOf('days')
            }

            if (selectedPeriodType === 'month') {
                date = moment(this.selectedDate).add(day, 'month').startOf('days')
            }

            updateSelectedPeriod(selectedPeriodType, date.endOf('days').toString())
        },

        action_BeforeDay() {
            this.handler_DayChange(this.selectedPeriodType, -1)
        },

        action_NextDay() {
            this.handler_DayChange(this.selectedPeriodType, 1)
        }
    }
}
</script>
